<template>
  <SectionTransformTable>
    <SidebarGroupUser
      :datas="travelAgent"
      :functions="functionsParsed"
      @refetch="
        (Id) => {
          refetchData();
          fetchDetailGroupUser({
            TaUserGroup: {
              Id,
            },
          });
        }
      "
      :data="detailGroupUser"
      :is-show.sync="isShowSidebar"
    />
    <ModalGroupUser v-if="isShowModal" @refetch="refetchData" :is-show.sync="isShowModal" />
    <SearchList @search="refetchData" title="ar_client_group_user">
      <FormItems :items="formItems" :form-data.sync="searchVal" />
    </SearchList>
    <b-card>
      <EzTable
        :actions="actions"
        ref="tableRef"
        @action-1="
          (data) =>
            fetchDetailGroupUser({
              TaUserGroup: {
                Id: data.data.Id,
              },
            })
        "
        @action-2="(data) => deleteGroupUser({ TaUserGroup: { Id: data.data.Id } })"
        :columns="columns"
        :data-source-params="searchVal"
        :data-source="arClient.api_AP_RTUG01"
      >
        <template #toolbar>
          <PermissionButton
            :api-code="AP_ITUG01"
            variant="outline-primary"
            @click="isShowModal = true"
          >
            <ez-icon icon="ezAr-icon-plus-circle" />
            {{ $t("ar_common_add_new") }}
          </PermissionButton>
        </template>
      </EzTable>
    </b-card>
  </SectionTransformTable>
</template>
<script>
import { AP_DTUG01, AP_RTUG02 } from "@/api/constant";
import { defineComponent, ref, getCurrentInstance, onMounted } from "@vue/composition-api";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";
import SearchList from "../ultils/SearchList/SearchList.vue";
import FormItems from "../ultils/Form/FormItems.vue";
import { arClient } from "@/api/ar-client";
import { convertCommonActiveStatus } from "../ultils/status";
import EzTable from "../ultils/Table/EzTable.vue";
import { AP_ITUG01 } from "@/api/constant";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import PermissionButton from "../ultils/Button/PermissionButton.vue";
import SidebarGroupUser from "./components/SidebarGroupUser.vue";
import ModalGroupUser from "./components/ModalGroupUser.vue";

export default defineComponent({
  setup() {
    const searchVal = ref({});
    const isShowModal = ref(false);
    const vm = getCurrentInstance().proxy;
    const isShowSidebar = ref(false);
    const tableRef = ref();
    const actions = ref([
      {
        apiCode: AP_RTUG02,
        title: "ar_common_detail",
        icon: "eye",
      },
      {
        apiCode: AP_DTUG01,
        danger: true,
        icon: "trash",

        title: "ar_common_delete",
      },
    ]);
    const refetchData = () => {
      tableRef.value.fetchData();
    };
    const columns = ref([
      {
        caption: "ar_client_group_code",
        width: 130,
        field: "TaUserGroupCode",
      },
      {
        caption: "ar_client_group_name",
        field: "NameVi",
      },
      {
        caption: "ar_client_group_type",
        width: "110px",
        field: "TaUserGroupType",
        align: "center",
      },
      {
        caption: "ar_client_company",
        field: "TravelAgent",
      },
      {
        width: "130px",
        caption: "ar_client_status",
        field: "InActive",
        cellTemplate: true,
        formatType: "text-variant",
        renderTextVariant: convertCommonActiveStatus,
      },
      {
        caption: "ar_client_created_person",
        field: "CreatedBy",
        cellTemplate: true,
        cellRender(data) {
          return `${data.data.CreatedBy} ${
            data.data.CreatedByStatus === 0 ? `(${vm.$t("ar_client_in_active")})` : ""
          }`;
        },
      },
      {
        caption: "ar_client_created_date",
        field: "CreatedDate",
        width: 100,
        cellTemplate: true,
        formatType: "date",
      },
    ]);
    const formItems = ref([
      {
        type: "string",
        label: "ar_client_find_follow",
        placeholder: "ar_client_find_by_group_user_group_authorize",
        name: "Code",
        wrapperClass: "col-4",
      },
      {
        type: "select",
        name: "TravelAgentId",
        dataSource: arClient.api_AR_RCL01,
        dataSourceParams: {
          IsCheckPermission: false,
        },
        customOptions: (options) =>
          options.map((option) => ({
            ...option,
            CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
          })),
        labelOption: "CodeName",
        label: "ar_client_company",
        placeholder: "ar_client_company",
        wrapperClass: "col-3",
      },
      {
        type: "select",
        dataSource: [
          { Id: 1, Label: vm.$t("ar_client_active") },
          { Id: 0, Label: vm.$t("ar_client_in_active") },
        ],
        name: "Status",
        labelOption: "Label",
        label: "ar_client_status",
        wrapperClass: "col-3",
      },
    ]);
    const { data: detailGroupUser, fetchData: fetchDetailGroupUser } = useFetch(
      arClient.api_AP_RTUG02,
      {
        nextFunction() {
          isShowSidebar.value = true;
        },
      }
    );
    const { fetchData: deleteGroupUser } = useFetch(arClient.api_AP_DTUG01, {
      nextFunction() {
        refetchData();
      },
      showLoading: true,
      successMessageMessage: "ar_client_delete_success",
    });

    const { fetchData: fetchTravelAgent, data: travelAgent } = useFetch(arClient.api_AR_RCL01);
    onMounted(() => {
      fetchTravelAgent({ IsCheckPermission: false, Sort: "NameVi", Order: "ASC" });
    });
    return {
      AP_ITUG01,
      travelAgent,
      tableRef,
      formItems,
      searchVal,
      columns,
      refetchData,
      isShowModal,
      isShowSidebar,
      actions,
      deleteGroupUser,
      fetchDetailGroupUser,
      detailGroupUser,
    };
  },
  components: {
    PermissionButton,
    SectionTransformTable,
    SearchList,
    FormItems,
    EzTable,
    SidebarGroupUser,
    ModalGroupUser,
  },
});
</script>
